<template>
  <div>
    <Nav></Nav>
    <div style="height: 80px"></div>
    <div class="download-contents">
        <div class="banner_img">
            <img :src="loadurl" alt="" srcset="">
        </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../component/Nav.vue";
export default {
  name:'helpDown',
  data() {
    return {
        loadurl:''
    };
  },
  created(){
      let {infoId} = this.$route.query
      if(infoId){
          if(infoId ==1){
            console.log( '21312',this.$route.query);
            // 音言
            this.loadurl = 'https://oss.ansongqiubo.com/website/9070-170.png?time='+ new Date().getTime()
          }
          if(infoId == 2){
            // 音言
            // this.loadurl = 'https://oss.ansongqiubo.com/website/00875.png?time=' + new Date().getTime()
            // 太仓
            this.loadurl = 'https://oss.ansongqiubo.com/website/B2-20170471.png?time=' + new Date().getTime()
          }
      }
  },
  components: {
    Nav,
  },
};
</script>

<style lang='scss' scope>

.download-contents {
  display: flex;
  justify-content: center;
  background:linear-gradient(to bottom right,#f9f9f9,50%,#f3f3f3);
  .banner_img{
      border-radius:4px;
      max-width:85vh;
      img{
          margin: 20px 0;
      max-width:85vh;
      }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/template/website.vue